import React from "react";

// Lista curta com barra proporcional (produtos, clientes).
export default function Ranking({ titulo, itens, rotulo, valor, detalhe, vazio, e2e }) {
  const maximo = Math.max(1, ...(itens || []).map(valor));
  return (
    <section className="rounded-xl border bg-card p-4 sm:p-5" data-e2e={e2e}>
      <h3 className="font-semibold mb-3">{titulo}</h3>
      {!itens?.length ? <p className="text-sm text-muted-foreground py-4 text-center">{vazio}</p> : (
        <ol className="space-y-2.5">
          {itens.map((it, i) => (
            <li key={i}>
              <div className="flex justify-between gap-3 text-sm">
                <span className="truncate">{rotulo(it)}</span>
                <span className="text-muted-foreground tabular-nums shrink-0">{detalhe(it)}</span>
              </div>
              <div className="h-1.5 rounded-full bg-muted mt-1 overflow-hidden">
                <div className="h-full rounded-full bg-sky-500" style={{ width: `${(valor(it) / maximo) * 100}%` }} />
              </div>
            </li>
          ))}
        </ol>
      )}
    </section>
  );
}
